// Validación de rutas de retorno ("volver a X", `?origen=`, `location.state.from`)
// para que nunca puedan sacar al usuario del ERP (open redirect). Una ruta
// interna válida: empieza con "/" (ruta relativa al origen actual), nunca
// "//" (protocol-relative, ej. "//evil.com" que el navegador resolvería como
// absoluta) y nunca contiene un esquema (ej. "javascript:", "https:").
export function esRutaInternaSegura(ruta: string | null | undefined): ruta is string {
  if (!ruta) return false;
  if (!ruta.startsWith("/")) return false;
  // Algunos navegadores normalizan "\" a "/" al resolver una URL — sin esto,
  // "/\evil.com" colaría como ruta "interna" y terminaría siendo
  // protocol-relative ("//evil.com") una vez normalizada.
  const normalizada = ruta.replace(/\\/g, "/");
  if (normalizada.startsWith("//")) return false;
  if (/^\/\S*:/.test(normalizada)) return false;
  return true;
}
